<template>
  <div class="columns">
    <div class="column">
      <button @click="toggleCreate" class="button is-primary is-small">create keyword</button>
    </div>
    <div class="column">
      <div class="btn-pair">
        <button @click="toggleUploadPref" class="button is-black is-small">upload keywords</button>
        <button @click="downloadKeywords" class="button is-link is-small">download keywords</button>
      </div>
    </div>
  </div>
  <div class="table-container">
    <table class="table is-fullwidth">
      <thead>
      <tr>
        <th class="has-text-left">name</th>
        <th class="has-text-left">main name</th>
        <th class="has-text-left">parent</th>
        <th class="has-text-left">keyword</th>
        <th class="actions-header has-text-centered">actions</th>
      </tr>
      </thead>
      <tbody>
      <tr class="update" v-for="(pref, key) in preferences" v-bind:key="key">
        <td>{{ pref.name }}</td>
        <td>{{ pref.main_name }}</td>
        <td>{{ pref.parent_name }}</td>
        <td>{{ pref.keyword }}</td>
        <td class="actions-cell">
          <div class="action-buttons">
            <button @click="_ => toggleUpdate(key)" class="button is-info is-small action-btn">update</button>
            <button v-if="pref.archived === false" @click="archiveUnarchivePreference(key)" class="button is-warning is-small action-btn">archive</button>
            <button v-if="pref.archived === true" @click="archiveUnarchivePreference(key)" class="button is-primary is-small action-btn">unarchive</button>
            <button @click="deletePreference(key)" class="button is-danger is-small action-btn">delete</button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <CreatePreference :preferences="preferences"
                    v-on:preferences:created="loadPreferences"
                    v-on:close="toggleCreate"
                    v-if="createpref"></CreatePreference>
  <UpdatePreference :preferences="preferences"
                    :pref="selectedpref"
                    v-on:preferences:updated="loadPreferences"
                    v-on:close="updatepref = false"
                    v-if="updatepref"></UpdatePreference>
  <UploadPreference 
      v-if="uploadPref"
      v-on:close="() => uploadPref = false"
      v-on:done="() => uploadPref = false"
      v-on:reload="loadPreferences"
    ></UploadPreference>
</template>

<script>
import {deletePreference, getPreferences, updatePreference, exportPreferences} from "../../api/api"

//TODO one component
import CreatePreference from "./CreatePrefence";
import UpdatePreference from "./UpdatePrefence";
import UploadPreference from "./UploadPreference";

export default {
  data() {
    return {
      preferences: [], 
      createpref: false, 
      updatepref: false, 
      selectedpref: {},
      uploadPref: false,
    }
  },
  components: {
    CreatePreference,
    UpdatePreference,
    UploadPreference
},
  methods: {
    async downloadKeywords() {
      try {
        const resp = await exportPreferences();
        const blob = new Blob([resp.data], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const filename = 'preferences.csv';
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error(e);
        alert('Failed to download keywords.');
      }
    },
    toggleUploadPref() {
      this.uploadPref = !this.uploadPref;
    },
    toggleCreate() {
      this.createpref = !this.createpref
    },
    toggleUpdate(key) {
      console.log("update")
      this.selectedpref = this.preferences[key]
      this.updatepref = !this.updatepref
    },
    deletePreference(key) {
      deletePreference(this.preferences[key].id)
       .then(this.loadPreferences);
    },
    async archiveUnarchivePreference(key) {
      await updatePreference(this.preferences[key].id, {
        archived: !this.preferences[key].archived
      });
      await this.loadPreferences()
    },

    async getPrefs() {
      try {
        return await getPreferences().then(resp => resp.data)
      } catch (e) {
        console.error(e)

        return []
      }
    },
    async loadPreferences() {
      this.preferences = await this.getPrefs()
    }
  },
  async created() {
    await this.loadPreferences()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.update {
  cursor: pointer;
}

.columns {
  align-items: center;
}

/* Match spacing style used between action buttons in the list */
.btn-pair {
  display: inline-flex;
  column-gap: 0.5rem;
}

/* Push the download button to the far right within the column */
.column:last-child {
  display: flex;
  justify-content: flex-end;
}

/* Table container for responsive behavior */
.table-container {
  overflow-x: auto;
}

/* Table styling */
.table {
  font-size: 0.9rem;
  table-layout: auto; /* Allow dynamic column widths */
}

/* Reserve a narrow column for keyword (now 4th) if needed */
th:nth-child(4), td:nth-child(4) { 
  white-space: nowrap; 
}

/* Actions column styling */
.actions-header,
.actions-cell {
  width: auto;
  min-width: fit-content;
  white-space: nowrap;
}

/* Action buttons container */
.action-buttons {
  display: flex;
  gap: 0.25rem;
  justify-content: flex-end;
  flex-wrap: nowrap;
}

/* Make all action buttons the same width */
.action-btn { 
  min-width: 7rem;
  width: 7rem;
  text-align: center;
  flex-shrink: 0; /* Prevent buttons from shrinking */
}

.table .button.is-small { 
  padding-left: 0.6em; 
  padding-right: 0.6em; 
}

/* RESPONSIVE: Mobile and tablet behavior */
@media (max-width: 1024px) {
  /* Header button list: stack and left-align on mobile */
  .column:last-child {
    justify-content: flex-start;
    margin-top: 0.5rem;
  }
  .btn-pair {
    flex-wrap: wrap;
    row-gap: 0.5rem;
    column-gap: 0.5rem;
  }
  .btn-pair .button {
    width: 100%;
  }

  /* Stack action buttons vertically on smaller screens */
  .action-buttons {
    flex-direction: column;
    gap: 0.25rem;
    align-items: stretch;
  }
  
  .actions-cell {
    white-space: normal;
    min-width: 8rem;
    padding: 0.75em;
  }
  
  .action-btn {
    width: 100%;
    min-width: auto;
  }
}

/* Even smaller screens */
@media (max-width: 768px) {
  .table { 
    font-size: 0.85rem; 
  }
  .table .button.is-small { 
    padding-left: 0.5em; 
    padding-right: 0.5em; 
    font-size: 0.75rem;
  }
}

/* Very small screens - hide some columns if needed */
@media (max-width: 480px) {
  /* You can hide less important columns on very small screens */
  th:nth-child(2), td:nth-child(2) { /* main name column */
    display: none;
  }
  /* Optionally also hide parent name to save space */
  th:nth-child(3), td:nth-child(3) { /* parent name column */
    display: none;
  }
  
  .actions-cell {
    min-width: 6rem;
  }
}
</style>
